export default __webpack_public_path__ + "static/media/waiting_search.f9c70730.svg";